import React from 'react';
import Departments from './Departments';
import FormWrapper from './FormWrapper';
import ComplaintSection from './ComplaintSection';
import Banner from '../Banner';
import { bannerContactSmall } from '../Banner/modules';

const Contact = () => {
  return (
    <div>
      {bannerContactSmall().map((item) => (
        <Banner {...item} />
      ))}
      <FormWrapper />
      <ComplaintSection />
      <Departments />
    </div>
  );
};

export default Contact;
